import ServiceActionTypes from '../../Actions/Service/ActionTypes';

export const serviceReducer = (state = { all: [], active: [], notActive: [] }, action) => {
    switch (action.type) {
        case ServiceActionTypes.FETCH_ALLSERVICES:
            return {
                ...state,
                all: action.payload,
                active: action.payload.filter(s => !!s.isActive),
                notActive: action.payload.filter(s => !s.isActive)
            };

        case ServiceActionTypes.FETCH_ENABLED_SERVICE:
            return {
                ...state,
                all: [...state.all.filter(item => action.payload.map(pl => pl.id).indexOf(item.id) < 0), ...action.payload],
                active: action.payload.length && action.payload.filter(s => !!s.isActive).length ? action.payload.filter(s => s.isActive === true) : state.active,
                notActive: action.payload.length && action.payload.filter(s => !s.isActive).length ? action.payload.filter(s => !s.isActive) : state.notActive,
            };

        case ServiceActionTypes.FETCH_DISABLED_SERVICE:
            return {
                ...state,
                all: [...state.all.filter(item => action.payload.map(pl => pl.id).indexOf(item.id) < 0), ...action.payload],
                active: action.payload.length && action.payload.filter(s => !!s.isActive).length ? action.payload.filter(s => s.isActive === true) : state.active,
                notActive: action.payload.length && action.payload.filter(s => !s.isActive).length ? action.payload.filter(s => !s.isActive) : state.notActive,
            };

        case ServiceActionTypes.FETCH_SERVICE_PAGE:
            return {
                ...state,
                all: action.payload.data.length ?
                    [
                        ...new Set([
                            ...state.all.filter(s => action.payload.data.map(it => it.id).length && action.payload.data.map(it => it.id).indexOf(s.id) < 0),
                            ...action.payload.data
                        ])
                    ] : state.all,
                active: action.payload.data.length ?
                    [
                        ...new Set([
                            ...state.active.filter(s => action.payload.data.map(it => it.id).length && action.payload.data.map(it => it.id).indexOf(s.id) < 0),
                            ...action.payload.data.filter(item => !!item.isActive)
                        ])
                    ] : state.active,
                notActive: action.payload.data.length ?
                    [
                        ...new Set([
                            ...state.notActive.filter(s => action.payload.data.map(it => it.id).length && action.payload.data.map(it => it.id).indexOf(s.id) < 0),
                            ...action.payload.data.filter(item => !item.isActive)
                        ])
                    ] : state.notActive
            };
        // return {
        //     ...state,
        //     all: action.payload.data.length ? [...new Set([...state.all, ...action.payload.data])] : state.all,
        //     active: action.payload.data.length ? [...new Set([...state.active, ...action.payload.data.filter(item => !!item.isActive)])] : state.active,
        //     notActive: action.payload.data.length ? [...new Set([...state.notActive, ...action.payload.data.filter(item => !item.isActive)])] : state.notActive
        // };

        case ServiceActionTypes.FETCH_SERVICE:
            return {
                ...state,
                all: [...state.all.filter(item => item.id !== action.payload.id), action.payload],
                active: action.payload && action.payload.isActive ? [...state.active.filter(item => item.id !== action.payload.id), action.payload] : state.active,
                notActive: action.payload && !action.payload.isActive ? [...state.notActive.filter(item => item.id !== action.payload.id), action.payload] : state.notActive
            };

        case ServiceActionTypes.ADD_SERVICE:
            return {
                ...state,
                all: [...state.all, action.payload],
                notActive: [...state.notActive, action.payload]
            };

        case ServiceActionTypes.EDIT_SERVICE:
            return {
                ...state,
                all: [
                    ...state.all.filter(item => item.id !== action.payload.id),
                    { ...state.all.filter(item => item.id === action.payload.id)[0], ...action.payload }
                ],
                active: action.payload && action.payload.isActive ?
                    [
                        ...state.active.filter(item => item.id !== action.payload.id),
                        { ...state.active.filter(item => item.id === action.payload.id)[0], ...action.payload }
                    ] :
                    state.active,
                notActive: action.payload && !action.payload.isActive ?
                    [
                        ...state.notActive.filter(item => item.id !== action.payload.id),
                        { ...state.notActive.filter(item => item.id === action.payload.id)[0], ...action.payload }
                    ] :
                    state.notActive
            };

        case ServiceActionTypes.UPDATE_SERVICE:
            return {
                ...state,
                all: [
                    ...state.all.filter(item => item.id !== action.payload.servicesId),
                    {
                        ...state.all.filter(item => item.id === action.payload.servicesId)[0][action.payload.property].filter(t => t.id !== action.payload.id)[0],
                        ...action.payload.data
                    }
                ],
                active: action.payload && action.payload.isActive ?
                    [
                        ...state.active.filter(item => item.id !== action.payload.servicesId),
                        { ...state.active.filter(item => item.id === action.payload.servicesId)[0], ...action.payload }
                    ] :
                    state.active,
                notActive: action.payload && !action.payload.isActive ?
                    [
                        ...state.notActive.filter(item => item.id !== action.payload.servicesId),
                        { ...state.notActive.filter(item => item.id === action.payload.servicesId)[0], ...action.payload }
                    ] :
                    state.notActive
            };

        case ServiceActionTypes.DELETE_SERVICE:
            return {
                ...state,
                all: [...state.all.filter(item => item !== action.payload)],
                active: [...state.active.filter(item => item !== action.payload)],
                notActive: [...state.notActive.filter(item => item !== action.payload)]
            };

        case ServiceActionTypes.SEARCH_SERVICE:
            return {
                ...state,
                all: [
                    ...state.all.filter(item =>
                        Object.entries(item).map(val =>
                            !val.includes(Object.entries(action.payload).map(b => b[0])[0]) &&
                            !val.includes(Object.entries(action.payload).map(b => b[1])[0]))[0]
                    ),
                    { ...action.payload }
                ]
            };

        case ServiceActionTypes.SEARCH_SERVICE_BYPROVIDERID:
            return {
                ...state,
                all: action.payload.length ?
                    [...state.all.filter(item => item.providerId !== action.payload[0].providerId), ...action.payload] :
                    state.all,
            };

        case ServiceActionTypes.ENABLE_SERVICE:
            return {
                ...state,
                all: [...state.all.filter(item => item.id !== action.payload.id), action.payload],
                notActive: [...state.notActive.filter(item => item.id !== action.payload.id)],
                active: [...state.active, action.payload]
            };

        case ServiceActionTypes.DISABLE_SERVICE:
            return {
                ...state,
                all: [...state.all.filter(item => item.id !== action.payload.id), action.payload],
                active: [...state.active.filter(item => item.id !== action.payload.id)],
                notActive: [...state.notActive, action.payload]
            };

        case ServiceActionTypes.ENABLE_SHOW_IN_HOME:
            return {
                ...state,
                all: [...state.all.map(item => item.id === action.payload.id ? action.payload : item)],
                notActive: [...state.notActive.map(item => item.id === action.payload.id ? action.payload : item)],
                active: [...state.active.map(item => item.id === action.payload.id ? action.payload : item)]
            };

        case ServiceActionTypes.DISABLE_SHOW_IN_HOME:
            return {
                ...state,
                all: [...state.all.map(item => item.id === action.payload.id ? action.payload : item)],
                active: [...state.active.map(item => item.id === action.payload.id ? action.payload : item)],
                notActive: [...state.notActive.map(item => item.id === action.payload.id ? action.payload : item)]
            };

        case ServiceActionTypes.ENABLE_SHOW_IN_SLIDER:
            return {
                ...state,
                all: [...state.all.map(item => item.id === action.payload.id ? action.payload : item)],
                notActive: [...state.notActive.map(item => item.id === action.payload.id ? action.payload : item)],
                active: [...state.active.map(item => item.id === action.payload.id ? action.payload : item)]
            };

        case ServiceActionTypes.DISABLE_SHOW_IN_SLIDER:
            return {
                ...state,
                all: [...state.all.map(item => item.id === action.payload.id ? action.payload : item)],
                active: [...state.active.map(item => item.id === action.payload.id ? action.payload : item)],
                notActive: [...state.notActive.map(item => item.id === action.payload.id ? action.payload : item)]
            };

        default:
            return state;
    }
}